<template>
  <div @click="skipOnBoarding()" style="width: 100vw; height: 100vh">
    <v-col>
      <v-row class="first">
        <div class="text-on-boarding">
          Saigon is under
          <br />attack by <br />Plastic Monsters
        </div>
      </v-row>
      <v-row class="second">
        <div class="text-on-boarding">
          Most come from
          <br />our convenience
        </div>
      </v-row>
      <v-row class="third">
        <div class="text-on-boarding" style="font-size: 40px">
          Help us to
          <br />fight them!
          <br />
          <span
            style="
              text-transform: lowercase;
              font-size: 30px;
              letter-spacing: 2px;
            "
            >with...</span
          >
        </div>
      </v-row>
      <v-row class="fourth" justify="center">
        <div class="text-on-boarding" style="font-size: 50px">AYA cup</div>
        <v-fade-transition>
          <v-avatar
            size="500"
            tile
            style="
              margin-top: -20px;
              animation: zoominout 1s infinite;
              position: absolute;
            "
          >
            <v-img src="/img/cup.png"></v-img>
          </v-avatar>
        </v-fade-transition>
      </v-row>
    </v-col>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "OnBoarding",
  metaInfo() {
    return {
      meta: [
        {
          name: "theme-color",
          content: this.color,
        },
      ],
    };
  },
  data() {
    return {
      counter: null,
    };
  },
  computed: {
    ...mapState(["routeParams"]),
    color() {
      return "#62A0F0";
    },
  },
  mounted() {
    let self = this;
    this.counter = setTimeout(function () {
      self.skipOnBoarding();
    }, 13000);
  },
  methods: {
    skipOnBoarding() {
      clearTimeout(this.counter);
      this.$router.push(`/guest/TZpsRh6twpvS4ovycbTp`);
    },
  },
};
</script>
<style>
@font-face {
  font-family: adumu;
  src: url("../assets/static/adumu.woff");
}
.text-on-boarding {
  text-align: center;
  font-size: 30px;
  color: white;
  font-family: adumu;
  text-transform: uppercase;
  letter-spacing: 3px;
  width: 100vw;
}

.first {
  position: fixed;
  top: -50px;
  animation: top-to-center-1 10000s;
}
.second {
  position: fixed;
  bottom: -100px;
  animation: top-to-center-2 10000s;
}

.third {
  position: fixed;
  top: -150px;
  animation: top-to-center-3 10000s;
}

.fourth {
  position: fixed;
  top: -350px;
  animation: top-to-center-4 10000s;
}

@keyframes top-to-center-1 {
  0% {
    transform: translateY(0) scale(0.4);
  }
  0.01% {
    transform: translateY(90px) scale(1);
  }
  0.03% {
    transform: translateY(90px) scale(1);
    opacity: 1;
  }
  0.04% {
    transform: translateY(90px) scale(1);
    opacity: 0;
  }
  100% {
    transform: translateY(90px) scale(0.7);
  }
}

@keyframes top-to-center-2 {
  0.03% {
    transform: translateY(0px) scale(0.4);
  }
  0.04% {
    transform: translateY(-180px) scale(1);
    opacity: 1;
  }
  0.06% {
    transform: translateY(-180px) scale(1);
    opacity: 1;
  }
  0.07% {
    transform: translateY(-180px) scale(1);
    opacity: 0;
  }
  100% {
    transform: translateY(-180px) scale(1);
  }
}

@keyframes top-to-center-3 {
  0% {
    transform: translateY(0) scale(0.4);
  }
  0.06% {
    transform: translateY(0) scale(0.4);
  }
  0.07% {
    transform: translateY(40vh) scale(1);
  }
  0.09% {
    transform: translateY(40vh) scale(1);
    opacity: 1;
  }
  0.1% {
    transform: translateY(40vh) scale(1);
    opacity: 0;
  }
  100% {
    transform: translateY(40vh) scale(0.7);
  }
}

@keyframes top-to-center-4 {
  0% {
    transform: translateY(0) scale(0.4);
  }
  0.09% {
    transform: translateY(0) scale(0.4);
  }
  0.1% {
    transform: translateY(500px) scale(1);
  }
  0.14% {
    transform: translateY(500px) scale(1);
    opacity: 1;
  }
  100% {
    transform: translateY(500px) scale(1);
  }
}
</style>
